module.exports = __webpack_public_path__ + "static/media/ic-SAQ.460662ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-SAQ.svg
// module id = 1290
// module chunks = 17